import styled from "styled-components/macro"
import { Color } from "../../../data/style/variables"

export const ContainerElement = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  height: 100%;
  overflow: hidden;
`
type PageTitleElementProps = {
  color?: Color
}

export const PageTitleElement = styled.div<PageTitleElementProps>`
  text-transform: uppercase;
  font-size: 27px;
  font-weight: bold;
  letter-spacing: 10px;
  text-align: center;
  margin-bottom: 75px;
  color: ${props => (props.color ? props.color : "#000")};
`

export const PageLinkElement = styled.div`
  margin: 0 auto;
  opacity: 0.75;
  text-transform: uppercase;
  max-width: 175px;
  display: flex;
  flex-direction: column;
`

export const InnerContainerElement = styled.div`
  padding: 15px;
`

export const ArrowContainerElement = styled.div`
  margin-top: 15px;
`
